import { ReactNode } from "react";
import { SecondaryButton } from "../../Button";
import { useModalContext } from "../ModalContext";

type CloseButtonProps = {
  children?: ReactNode;
};

export const CloseButton = ({ children = "Close" }: CloseButtonProps) => {
  const { onClose } = useModalContext();
  return (
    <SecondaryButton type="button" onClick={onClose} name="close">
      {children}
    </SecondaryButton>
  );
};
